import { render, staticRenderFns } from "./AddressInfo.vue?vue&type=template&id=f5738bce&scoped=true&"
import script from "./AddressInfo.vue?vue&type=script&lang=js&"
export * from "./AddressInfo.vue?vue&type=script&lang=js&"
import style0 from "./AddressInfo.vue?vue&type=style&index=0&id=f5738bce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../东方蚂蚁/e-shop/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5738bce",
  null
  
)

export default component.exports